import * as types from './mutations-types'
import {DOWNLOAD_FILE} from '../../../../../common/utils/uploadFileUtil'

export default {
  [types.MY_ORDER_LIST] (state, data) {
    let list = data.dataList.filter(item => {
      let imgList = []
      if (item.codeToFileIds && item.codeToFileIds.details) {
        item.codeToFileIds.details.filter((itemTwo, indexTwo) => {
          let img = `${DOWNLOAD_FILE}${itemTwo}?X-Authorization=${localStorage.getItem('token')}`
          imgList.push(img)
        })
      }
      item.codeToFileIds.details = imgList
      return item
    })
    state.myOrderList = list
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-extended-insurance/store/mutations.js